module.exports = __webpack_public_path__ + "img/ja_ja.95a86b20.png";